<div
    class="kpi-card"
    [ngClass]="'kpi-card--' + variant"
    [class.kpi-card--active]="active"
    role="button"
    tabindex="0"
>
    <div class="kpi-card-header">
        <span class="kpi-card-tag">{{ tag }}</span>
        <div class="kpi-icon-wrapper" aria-hidden="true">
            <span class="material-icons">{{ icon }}</span>
        </div>
    </div>
    <div class="kpi-card-body">
        <div class="kpi-value-row">
            <span class="kpi-value">{{ value }}</span>
            <span class="kpi-unit" *ngIf="unit">{{ unit }}</span>
        </div>
        <div class="kpi-title">{{ title }}</div>
        <div class="kpi-subtext" *ngIf="subtext">{{ subtext }}</div>
    </div>
</div>
